import React from 'react';

const { Children: { toArray } } = React;

export const getMissingProps = (component, requiredProps) => {
  const props = component && component.props;
  if (!props) {
    return requiredProps;
  }

  return requiredProps.filter(prop =>
    !Object.prototype.hasOwnProperty.call(props, prop));
};

export const validate = (requiredProps, props, propName) => {
  const components = toArray(props[propName]);

  const errors = components.reduce((result, component, i) => {
    const missingProps = getMissingProps(component, requiredProps);
    if (missingProps.length) {
      result.push(`Component in props "${propName}" at index ${i} doesn't have all required properties. Missing properties: ${missingProps}`); // eslint-disable-line max-len
    }
    return result;
  }, []);

  return errors;
};

/**
 * Validate that each children is either null, false, undefined or an element with the given props.
 * @param requiredProps
 */
const componentsWithProps = (...requiredProps) => {
  const hasPropsPropType = (props, propName) => {
    const errors = validate(requiredProps, props, propName);

    return errors.length ? new Error(errors.join('. ')) : null;
  };

  hasPropsPropType.isRequired = (props, propName) => {
    const components = toArray(props[propName]);
    if (!components.length) {
      return new Error(`At least one child must be provided in prop "${propName}"`);
    }

    const errors = validate(requiredProps, props, propName);

    return errors.length ? new Error(errors.join('. ')) : null;
  };

  return hasPropsPropType;
};


export default componentsWithProps;
